import type {
  ServiceFeedbackCreateApiData,
  ServiceFeedbackCreateApiResponses,
  ServiceFeedbackDeleteApiData,
  ServiceFeedbackDeleteApiResponses,
  ServiceFeedbackListApiData,
  ServiceFeedbackListApiResponses,
  ServiceFeedbackOverviewApiData,
  ServiceFeedbackOverviewApiResponses,
  ServiceFeedbackUpdateApiData,
  ServiceFeedbackUpdateApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getFeedbackUrls = {
  deleteFeedback: dataEndpoint<ServiceFeedbackDeleteApiData, ServiceFeedbackDeleteApiResponses>({
    getUrl: ({ serviceFeedbackId }) => apiUrl(`service-feedbacks/${serviceFeedbackId}/`)
  }),
  getFeedbacksOverview: dataEndpoint<ServiceFeedbackOverviewApiData, ServiceFeedbackOverviewApiResponses>({
    getUrl: (queryParams) => apiUrl('service-feedbacks/overview/', queryParams)
  }),
  getPaginatedFeedbacks: dataEndpoint<ServiceFeedbackListApiData, ServiceFeedbackListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-feedbacks/', queryParams)
  }),
  patchFeedback: responseEndpoint<ServiceFeedbackUpdateApiData, ServiceFeedbackUpdateApiResponses>({
    getUrl: ({ serviceFeedbackId }) => apiUrl(`service-feedbacks/${serviceFeedbackId}/`),
    getBody: ({ serviceFeedbackId: _, ...body }) => body
  }),
  postFeedback: responseEndpoint<ServiceFeedbackCreateApiData, ServiceFeedbackCreateApiResponses>({
    getUrl: () => apiUrl('service-feedbacks/'),
    getBody: (data) => data
  })
};
